export enum ConsumerFeedbackProvider {
  SIMPLESAT = 'simplesat',
}

export enum SimplesatSurveys {
  CSAT = 'csat',
}

export type SimplesatSurveyLanguageConfig = {
  surveyToken: string;
};

export type SimplesatSurveysConfig = {
  [SimplesatSurveys.CSAT]?: {
    en: SimplesatSurveyLanguageConfig;
    fr?: SimplesatSurveyLanguageConfig;
  };
};
